import { CircularProgress, IconButton } from '@material-ui/core';
import styled from 'styled-components';

export const ModalHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  div {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 80px;
    height: 80px;
    border-radius: 50%;
    background-color: rgba(246, 68, 68, 0.2);
    margin: none;
    svg {
      color: #f64444;
      font-size: 50px;
    }
  }
  h1 {
    color: #101d40;
    font-size: 20px;
    text-align: center;
    font-weight: 800;
    margin-top: 15px;
    font-family: 'Sora', sans-serif;
  }
  button {
    font-family: Sora, sans-serif;
    position: absolute;
    top: 10px;
    right: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background-color: rgba(215, 222, 233, 0.25);
    svg {
      color: #4f4f4f;
      font-size: 22px;
    }
    &:hover {
      background-color: rgba(215, 222, 233, 0.5);
    }
  }
`;

export const ModalBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  min-width: 300px;
  overflow-y: auto;
  padding-right: 4px;

  scrollbar-width: thin;
  scrollbar-color: black transparent;

  &::-webkit-scrollbar {
    width: 3px;
    height: 3px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
    padding: 2px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #a1a1a1;
  }

  h2 {
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    color: var(--color-alba-grandeza);
    font-family: Sora, sans-serif;
  }

  h3 {
    font-weight: 600;
    font-size: 18px;
    line-height: 23px;
    color: var(--color-navy-blue);
    font-family: Sora, sans-serif;

    span {
      color: var(--color-alba-grandeza);
      font-weight: 400;
      font-size: 14px;
    }
  }

  p {
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    color: var(--color-alba-grandeza);
    font-family: Sora, sans-serif;
  }

  .out__of__stock {
    color: var(--color-red);
    font-weight: 600;
    font-size: 14px;
    line-height: 18px;
    text-align: right;
    font-family: Sora, sans-serif;
  }

  .prices {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    text-align: right;

    p {
      font-weight: 400;
      font-size: 14px;
      line-height: 18px;
      color: var(--color-alba-grandeza);
      font-family: Sora, sans-serif;
    }

    .old__value {
      text-decoration: line-through;
    }

    .discount__value {
      color: var(--color-red);
      font-weight: 600;
    }

    .new__value {
      color: var(--color-blue);
      font-weight: 600;
    }
  }

  .complements {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .quantity {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 4px;
    user-select: none;

    p {
      font-family: Sora, sans-serif;
      font-weight: 400;
      font-size: 16px;
      line-height: 18px;
      color: var(--color-navy-blue);
    }

    input {
      font-family: Sora, sans-serif;
      font-weight: 400;
      font-size: 16px;
      line-height: 18px;
      color: var(--color-navy-blue);
      height: 1.5rem;
      max-width: 3.5rem;
    }
  }

  .colors,
  .sizes {
    display: flex;
    gap: 10px;
  }

  .comments {
    > div {
      min-height: 80px;
    }
  }
`;

export const ModalFooter = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  user-select: none;
`;

export const CustomIconButton = styled(IconButton)`
  :hover {
    background-color: #329bfc1a;
  }

  :disabled {
    svg {
      color: var(--color-gray-800);
    }
  }
  svg {
    color: var(--color-blue);
  }
`;

export const CustomCircularProgress = styled(CircularProgress)`
  color: var(--color-blue);
`;
